module.exports = __webpack_public_path__ + "static/img/diastasis-recti.cb176307.png";